<!-- card snippet component -->
<div class="card">
  <div class="card-header">
    <ng-content select=".card-title"></ng-content>

    <i
      class="code-icon"
      (click)="snippetCode.isCollapsed = !snippetCode.isCollapsed"
      [attr.aria-expanded]="!snippetCode.isCollapsed"
    ></i>
  </div>

  <!--? content wrapped with .card-body -->
  <ng-content select=".card-body"></ng-content>

  <!--? content without any wrapper -->
  <ng-content></ng-content>

  <!-- snippet code -->
  <div [ngbCollapse]="snippetCode.isCollapsed">
    <div class="card-body pt-0">
      <!-- nav tabs -->
      <ul ngbNav #nav="ngbNav" [(activeId)]="snippetCode.active" class="nav-tabs">
        @if (snippetCode.html) {
          <li [ngbNavItem]="'html'">
            <a ngbNavLink>HTML</a>
            <ng-template ngbNavContent>
              <div class="code-toggle">
                <pre>
                  @if (!copyCodeStatus) {
                    <i class="feather icon-copy font-medium-2 cursor-pointer text-white p-1" (click)= "copyCode(snippetCode.html)"></i>
                  }
                  @if (copyCodeStatus) {
                    <span class="text-white text-copied me-1 badge badge-secondary">copied !</span>
                  }
                  <code [highlight]="snippetCode.html" [languages]="['html']">
                  </code>
                </pre>
              </div>
            </ng-template>
          </li>
        }
        @if (snippetCode.ts) {
          <li [ngbNavItem]="'ts'">
            <a ngbNavLink>TS</a>
            <ng-template ngbNavContent>
              <div class="code-toggle">
                <pre>
                  @if (!copyCodeStatus) {
                    <i class="feather icon-copy font-medium-2 cursor-pointer text-white float-end p-1" (click)= "copyCode(snippetCode.ts)"></i>
                  }
                  @if (copyCodeStatus) {
                    <span class="text-white float-end me-1 badge badge-secondary">copied !</span>
                  }
                  <code [highlight]="snippetCode.ts"  [languages]="['typescript']">
                  </code>
                </pre>
              </div>
            </ng-template>
          </li>
        }
        @if (snippetCode.scss) {
          <li [ngbNavItem]="'scss'">
            <a ngbNavLink>SCSS</a>
            <ng-template ngbNavContent>
              <div class="code-toggle">
                <pre>
                  @if (!copyCodeStatus) {
                    <i class="feather icon-copy font-medium-2 cursor-pointer text-white float-end p-1" (click)= "copyCode(snippetCode.scss)"></i>
                  }
                  @if (copyCodeStatus) {
                    <span class="text-white float-end me-1 badge badge-secondary">copied !</span>
                  }
                  <code [highlight]="snippetCode.scss"  [languages]="['scss']">
                  </code>
                </pre>
              </div>
            </ng-template>
          </li>
        }
        @if (snippetCode.json) {
          <li [ngbNavItem]="'json'">
            <a ngbNavLink>JSON</a>
            <ng-template ngbNavContent>
              <div class="code-toggle">
                <div class="mb-1 ms-50"></div>
                <pre>
                  @if (!copyCodeStatus) {
                    <i class="feather icon-copy font-medium-2 cursor-pointer text-white float-end p-1" (click)= "copyCode(snippetCode.json)"></i>
                  }
                  @if (copyCodeStatus) {
                    <span class="text-white float-end me-1 badge badge-secondary">copied !</span>
                  }
                  <code [highlight]="snippetCode.json"  [languages]="['json']">
                  </code>
                </pre>
              </div>
            </ng-template>
          </li>
        }
      </ul>
      <!--/ nav tabs -->

      <!-- nav tabs outlet -->
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
      <!--/ nav tabs outlet -->
    </div>
  </div>
  <!--/ snippet code -->
</div>
<!-- /card snippet component -->
